import { matchesVotingIdentity, parseVotingObject } from './voteRollover.js'

export const getStorage = () => {
  try {
    return typeof window !== 'undefined' ? window.localStorage || null : null
  } catch {
    return null
  }
}

const getStorageKeys = () => {
  const storage = getStorage()
  if (!storage) return []

  try {
    return Array.from({ length: storage.length }, (_, index) =>
      storage.key(index)
    ).filter(Boolean)
  } catch {
    return []
  }
}

const readStorage = (key) => {
  const storage = getStorage()
  if (!storage) return null

  try {
    return storage.getItem(key)
  } catch {
    return null
  }
}

const readJson = (key, fallback = null) => {
  const value = readStorage(key)
  if (!value) return fallback

  try {
    return JSON.parse(value)
  } catch {
    return fallback
  }
}

const writeStorage = (key, value) => {
  const storage = getStorage()
  if (!storage) return false

  try {
    storage.setItem(key, value)
    return true
  } catch {
    return false
  }
}

const writeJson = (key, value) => {
  try {
    return writeStorage(key, JSON.stringify(value))
  } catch {
    return false
  }
}

const removeStorage = (key) => {
  const storage = getStorage()
  if (!storage) return false

  try {
    storage.removeItem(key)
    return true
  } catch {
    return false
  }
}

const getFormStorageKey = (eventId, currentFormId) =>
  `form-${eventId}-${currentFormId}`

const getFormStorageIdentity = (key) => {
  if (typeof key !== 'string' || !key.startsWith('form-')) return null

  const value = key.slice('form-'.length)
  const separatorIndex = value.lastIndexOf('-')

  if (separatorIndex <= 0 || separatorIndex === value.length - 1) {
    return null
  }

  return {
    eventId: value.slice(0, separatorIndex),
    currentFormId: value.slice(separatorIndex + 1),
  }
}

const isDifferentVotingIdentity = (storedIdentity, currentIdentity) => {
  if (!storedIdentity || !currentIdentity) return false

  const eventChanged =
    storedIdentity.eventId &&
    currentIdentity.eventId &&
    storedIdentity.eventId !== currentIdentity.eventId

  const formChanged =
    storedIdentity.currentFormId &&
    currentIdentity.currentFormId &&
    String(storedIdentity.currentFormId) !==
      String(currentIdentity.currentFormId)

  const scopeChanged = ['projectId', 'season', 'host', 'environment'].some(
    (field) =>
      storedIdentity[field] &&
      currentIdentity[field] &&
      storedIdentity[field] !== currentIdentity[field]
  )
  return Boolean(eventChanged || formChanged || scopeChanged)
}

export {
  getStorageKeys,
  readStorage,
  readJson,
  writeStorage,
  writeJson,
  removeStorage,
  getFormStorageKey,
  getFormStorageIdentity,
  isDifferentVotingIdentity,
}

// Never prefill from another event/project or restore untagged SSO consent.
export const readVotingFormData = (meta) => {
  const value = parseVotingObject(readStorage('formData'))
  return matchesVotingIdentity(value, meta) ? value : null
}

export const readVotingLoginState = (meta) => {
  const value = parseVotingObject(readStorage('loginFormState'))
  return matchesVotingIdentity(value, meta) ? value : null
}
